
import { computed, defineComponent } from 'vue';
import { ClientConstants, ScreenerCardStyle } from './../client.constants';
import { Utils } from './../utils/Utils';

export default defineComponent({
  name: 'ScreenerCard',
  components: {},

  props: {
    idPrefix: { type: String, required: true },
    cardStyle: { type: Number, required: true },
    cusip: { type: String, required: false, default: '' },
    duration: { type: String, required: false, default: '' },
    apy: { type: String, required: false, default: '' },
    returnAmount: { type: String, required: false, default: 'N/A' },
    title: { type: String, required: false, default: '' },
    showFractionalIcon: { type: Boolean, required: false, default: false },
    searchURL: { type: String, required: false, default: '' }
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {},

  setup(props) {
    const isBuyCard = computed(() => props.cardStyle == ScreenerCardStyle.BUY_CARD);
    const isUnavailableCard = computed(() => props.cardStyle == ScreenerCardStyle.UNAVAILABLE_CARD);
    const isUnavailableCardTextId = computed(() => props.idPrefix + '-empty-card-text');
    const isUnavailableCardLinkId = computed(() => props.idPrefix + '-empty-card-link');
    const buyButtonId = computed(() => props.idPrefix + '-buy-button');
    const buttonCyId = computed(() => props.idPrefix + '-cy-button');
    const iconId = computed(() => props.idPrefix + '-card-icon');

    return {
      isBuyCard,
      isUnavailableCard,
      isUnavailableCardTextId,
      isUnavailableCardLinkId,
      buyButtonId,
      buttonCyId,
      iconId
    };
  },

  data: () => {
    return {
      clientConstants: ClientConstants,
      windowWidth: window.innerWidth
    };
  },
  methods: {
    onResize: function () {
      this.windowWidth = window.innerWidth;
    },
    fillInDuration: function (text: string): string {
      return text.replace('{{ duration }}', this.duration ?? '');
    },
    fillInApy: function (text: string): string {
      return text.replace('{{ apy }}', this.apy ?? '');
    },
    trackChoice() {
      try {
        switch (this.idPrefix) {
          case 'top':
            Utils.trackingFunction(this.clientConstants.SEARCH_PAGE, this.clientConstants.TOP_CARD_INTERACTION);
            break;
          case 'whole':
            Utils.trackingFunction(this.clientConstants.SEARCH_PAGE, this.clientConstants.WHOLE_CARD_INTERACTION);
            break;
          case 'fractional':
            Utils.trackingFunction(this.clientConstants.SEARCH_PAGE, this.clientConstants.FRACTIONAL_CARD_INTERACTION);
            break;
          default:
            break;
        }
      } catch (err) {
        console.log('Error In track analytics ' + err);
      }
    }
  }
});
